const additionalDivisions = [
  {
    id: 'osa-alue:kannelmäki',
    name: {
      fi: 'Kannelmäki',
      en: 'Kannelmäki',
      sv: 'Gamlas',
    },
  },
  {
    id: 'osa-alue:itäkeskus',
    name: {
      fi: 'Itäkeskus',
      en: 'Itäkeskus',
      sv: 'Östra centrum',
    },
  },
  {
    id: 'osa-alue:puistola',
    name: {
      fi: 'Puistola',
      en: 'Puistola',
      sv: 'Parkstad',
    },
  },
  {
    id: 'osa-alue:rastila',
    name: {
      fi: 'Rastila',
      en: 'Rastila',
      sv: 'Rastböle',
    },
  },
  {
    id: 'osa-alue:malminkartano',
    name: {
      fi: 'Malminkartano',
      en: 'Malminkartano',
      sv: 'Malmgård',
    },
  },
  {
    id: 'osa-alue:meri-rastila',
    name: {
      fi: 'Meri-Rastila',
      en: 'Meri-Rastila',
      sv: 'Havsrastböle',
    },
  },
];

export { additionalDivisions };
